import React, { useState, useEffect, useCallback } from "react";
import api from "../../services/api";
import useAuth from "../../hooks/useAuth";
import { Link } from "react-router-dom";
import ConfirmDialog from "../HtmlElements/ConfirmDialog";
import ScreenLoader from "../HtmlElements/ScreenLoader";
import Alert from "../HtmlElements/Alert";
import { useConfig } from "../../context/AppConfigContext";
import { useUser } from '../../context/UserContext';
import { getApiFieldValue } from '../../services/commonService';
import { updateData } from '../../services/accIqService';
import ActionDropdown from "../HtmlElements/ActionDropdown";
import SubmitActionButton from "../HtmlElements/SubmitActionButton";
import ActionCheckbox from '../HtmlElements/ActionCheckbox';

const Users = ({ isEmbedded = false }) => {
  useAuth(); // Ensure the user is authenticated

  const { user, handleLogout } = useUser();
  const current_role_key = user?.role_key;
  const [successMessage, setSuccessMessage] = useState("");
  /* eslint-disable no-unused-vars */
  const [loader, setLoader] = useState(false);
  const { appConfig } = useConfig();
  const [showPassword, setShowPassword] = useState(false);

  const [search, setSearch] = useState('');
  const [role, setRole] = useState('');
  const [account_manager, setAM] = useState('');
  const [user_status, setStatus] = useState(1);
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);
  /* eslint-enable no-unused-vars */
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage] = useState(10);
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [showArchive, setShowArchive] = useState(0);
  const [filter, setFilter] = useState({
    firstname: "",
    lastname: "",
    email: "",
    is_deleted: 0,
    is_active: ''
  });
  const [action, setAction] = useState({ action: '' });
  const [showConfirm, setShowConfirm] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);


  const [totalPages, setTotalPages] = useState(1);

  const [checkedItems, setCheckedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [updateDataStatus, setupdateDataStatus] = useState(false);

  const fetchUsers = useCallback(async () => {
    setLoader(true);
    try {
      if (filter.is_active === "") {
        delete (filter.is_active)
      }

      const response = await api.get("/users/get_users_list", {
        params: {
          page: currentPage,
          limit: perPage,
          sort_by: sortField,
          order: sortOrder,
          ...filter,
        },
      });
      setUsers(response.data.result.list);
      setTotalPages(Math.ceil(response.data.result.total / perPage));
    } catch (err) {
      setError(err.message || "Failed to fetch users");
    }
    setLoader(false);
  }, [currentPage, perPage, sortField, sortOrder, filter, updateDataStatus]);

  useEffect(() => {
    let successMessage = sessionStorage.getItem("successMessage");
    if (successMessage) {
      setSuccessMessage(successMessage);
      sessionStorage.removeItem("successMessage"); // Clear the message

      setTimeout(() => {
        setSuccessMessage("");
      }, 2000);
    }
    fetchUsers();
  }, [fetchUsers]);

  useEffect(() => {
    if (checkedItems.length > 0 && checkedItems.length === users.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [checkedItems])

  const handleDelete = async () => {
    try {
      await api.delete(`/users/delete_user/${userToDelete}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      setSuccessMessage("User Deleted Successfully...");
      fetchUsers();
      hideDeleteConfirm();
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  if (!appConfig) {
    return <div> </div>;
  }

  const user_status_options = appConfig.user_status_options;

  const showDeleteConfirm = (userId) => {
    setUserToDelete(userId);
    setShowConfirm(true);
  };

  const hideDeleteConfirm = () => {
    setShowConfirm(false);
    setUserToDelete(null);
  };

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);
  };

  const showArchived = (e) => {
    setCurrentPage(1);
    let temp = e.target;
    if (temp.value === "0" || temp.value === 0) {
      e.target.value = 1;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    } else {
      e.target.value = 0;
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
    setShowArchive(temp.value);
  };

  const handleFilterChange = (e) => {
    setCurrentPage(1);
    setFilter({ ...filter, [e.target.name]: e.target.value });
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSelectAll(false);
    setCheckedItems([]);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  if (current_role_key === undefined) {
    return <></>
  }
  if (current_role_key === 'CLIENT') {
    // navigate('/user_profile/profile');
    window.location.replace('/user_profile/profile');
  } else if (current_role_key === 'ANALYST') {
    // navigate('/dashboard');
    window.location.replace('users/user_dashboard');
  }

  return (
    <div className="add_user_wrapper">
      {loader && <ScreenLoader />}
      <div className={`container-fluid ${isEmbedded ? 'mt-0 p-0' : 'mt-3 p-4'}`}>
        {successMessage && <Alert type="success" message={successMessage} />}
        {error && <Alert type="danger" message={error} />}

        <div className={`row ${isEmbedded ? 'mx-0' : ''}`}>
          {!isEmbedded && (
            <div className="col-md-9">
              <h4 className="blue add_user_heading">User List</h4>
            </div>
          )}
          <div className={`${isEmbedded ? 'col-md-12 text-end' : 'col-md-3 align-right pb-3'}`}>
            <Link className="add_account_btn" to="/users/add_user">
              <i className="fa fa-plus" aria-hidden="true"></i> Add User
            </Link>
          </div>
        </div>

        <div className={`row mb-3 mt-4 ${isEmbedded ? 'mx-0' : ''}`}>
          <div className='col-md-9'>
            {/*<div className='left_filter'>
         <div className='admin_filter_head'>

              <h5 className=''>Filter</h5>
              </div>
              <div className="row">
                <div className="col ">
                  <input
                    type="text"
                    className="form-control custom_form_control"
                    placeholder="Filter by Name"
                    name="name"
                    value={filter.name}
                    onChange={handleFilterChange}
                  />
                </div>

            <div className="col ">
              <input
                type="text"
                className="form-control custom_form_control"
                placeholder="Filter by Email"
                name="email"
                autoComplete="Off"
                value={filter.email}
                onChange={handleFilterChange}
              />
            </div>          
            <div className="col  search_filter_user">
              <select
                className="custom_form_control form-control"
                as="select"
                id="selectfilter"
                name="is_active"
                value={filter.filterlist}
                onChange={handleFilterChange}
              >             
                <option key="" value="">
                  Select Filter
                </option>
                <option key="0" value="0">
                  Inactive
                </option>
                <option key="1" value="1">
                  Active
                </option>              
              </select>
            </div>
            <div className="col  show_archived">
            <input
              id="archived"
              type="checkbox"
              className="form-check-input custom_input_type"
              placeholder="Filter by Email"
              name="is_deleted"
              value={filter.is_deleted}
              onClick={showArchived}
            /> <label className="form-check-label custom_lable_type" htmlFor="archived">Archived</label>
          </div>
          </div>
          </div>
        
          </div>

          <div className="col-md-3">
          <div className='right_action'>
          <div className='admin_filter_head'>

          <h5 className=''>Actions</h5>
          </div>
          <div className='row'>

       

          <ActionDropdown page="users" action={action.action} setAction={setAction} />
          <SubmitActionButton
            page = 'users'
            checkedItems = {checkedItems}
            setCheckedItems = {setCheckedItems}
            action = {action.action}
            currentPage = {currentPage}
            setSelectAll = {setSelectAll}
            setupdateDataStatus = {setupdateDataStatus}
            setSuccessMessage = {setSuccessMessage}
            setCurrentPage = {setCurrentPage}
            setLoader = {setLoader}
            setAction = {setAction}
          />

        </div>
        </div> */}

          </div>

        </div>
        <div className='table-responsive'>
          <table className="table table-striped font14 table-bordered ">
            <thead>
              <tr className="cursor_p">
                {/* <th>
                  <ActionCheckbox
                    page = 'users'
                    users = {users}
                    checkedItems = {checkedItems}
                    setCheckedItems = {setCheckedItems}
                    selectAll = {selectAll}
                    setSelectAll = {setSelectAll}
                  />
                </th> */}
                {/* <th onClick={() => handleSort('firstname')}>
                  First Name {sortField === 'firstname' && (sortOrder === 'asc' ? '▲' : '▼')}
                </th>
                <th onClick={() => handleSort('lastname')}>
                  Last Name {sortField === 'lastname' && (sortOrder === 'asc' ? '▲' : '▼')}
                </th> */}
                <th onClick={() => handleSort('name')}>
                  User Name {sortField === 'name' && (sortOrder === 'asc' ? '▲' : '▼')}
                </th>
                <th onClick={() => handleSort('email')}>
                  Email {sortField === 'email' && (sortOrder === 'asc' ? '▲' : '▼')}
                </th>
                <th onClick={() => handleSort('roles')}>
                  Role {sortField === 'roles' && (sortOrder === 'asc' ? '▲' : '▼')}
                </th>
                <th onClick={() => handleSort("company_name")}>
                  Company Name{" "}
                  {sortField === "company_name" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("is_active")}>
                  Is Active{" "}
                  {sortField === "is_active" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("is_verified")}>
                  Verified{" "}
                  {sortField === "is_verified" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                <th onClick={() => handleSort("is_deleted")}>
                  Is Deleted{" "}
                  {sortField === "is_deleted" &&
                    (sortOrder === "asc" ? "▲" : "▼")}
                </th>
                {(showArchive === 0 || showArchive === "0") && (<th>Action</th>)}
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => {
                return (<tr key={index}>
                  {/* <td>
                    <ActionCheckbox
                      page = 'users'
                      checkedItems = {checkedItems}
                      setCheckedItems = {setCheckedItems}
                      related_id = {user.id}
                    />
                  </td> */}
                  {/* <td>{user.firstname}</td>
                  <td>{user.lastname}</td> */}
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>
                    {user.roles_list.map(item => (
                      [item.role_title]
                        .filter(Boolean)
                        .join(' | ')
                    )).reduce((acc, curr, index, arr) => {
                      return index === arr.length - 1 ? acc + curr : acc + curr + ' | ';
                    }, '')}
                  </td>
                  <td>{user.company_name}</td>
                  <td>{user.is_active === 1 ? "Yes" : "No"}</td>
                  <td>{user.is_verified === 1 ? "Yes" : "No"}</td>
                  <td>{user.is_deleted === 1 ? "Yes" : "No"}</td>
                  {(showArchive === 0 || showArchive === "0") && (<td>
                    <Link
                      to={`/users/edit_user/${user.id}`}
                      className="edit_right_margin cursor_p"
                    >
                      <span>
                        <i className="fa fa-edit blue"></i>
                      </span>
                    </Link>
                    <span
                      onClick={() => showDeleteConfirm(user.id)}
                      className="cursor_p"
                    >
                      <i className="fa fa-trash"></i>
                    </span>
                  </td>)}
                </tr>)
              })}
            </tbody>
          </table>
        </div>

        <nav>
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button onClick={handleFirstPage} className="page-link">
                First
              </button>
            </li>
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button onClick={handlePrevPage} className="page-link">
                Prev
              </button>
            </li>
            {getPageNumbers().map((pageNumber) => (
              <li
                key={pageNumber}
                className={`page-item ${pageNumber === currentPage ? "active" : ""
                  }`}
              >
                <button
                  onClick={() => handlePageChange(pageNumber)}
                  className="page-link"
                >
                  {pageNumber}
                </button>
              </li>
            ))}
            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                }`}
            >
              <button onClick={handleNextPage} className="page-link">
                Next
              </button>
            </li>
            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                }`}
            >
              <button onClick={handleLastPage} className="page-link">
                Last
              </button>
            </li>
          </ul>
        </nav>
      </div>
      <ConfirmDialog
        show={showConfirm}
        handleClose={hideDeleteConfirm}
        handleConfirm={handleDelete}
        title="Delete User"
        message="Are you sure you want to delete this User?"
      />
    </div>
  );
};

export default Users;
